export default __webpack_public_path__ + "static/media/buzzer - active.cff2f29a.svg";